import { render, staticRenderFns } from "./editbak.vue?vue&type=template&id=d42d00c6&scoped=true&"
import script from "./editbak.vue?vue&type=script&lang=js&"
export * from "./editbak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42d00c6",
  null
  
)

export default component.exports